import { getFunctionsBaseUrl, type RuntimeEnv } from "./config";
import type { AuthUser } from "./auth";

export type OwnerAccessResult = {
  allowed: boolean;
  role?: "owner";
  reason?: string;
};

export type OwnerAccessRepository = {
  verifyOwner(user: AuthUser): Promise<OwnerAccessResult>;
};

export function createServerOwnerAccessRepository(env: RuntimeEnv): OwnerAccessRepository {
  const baseUrl = getFunctionsBaseUrl(env);
  if (!baseUrl) {
    return {
      async verifyOwner() {
        return { allowed: false, reason: "Functions base URL is not configured." };
      }
    };
  }

  return {
    async verifyOwner(user) {
      const token = await user.getIdToken();
      const response = await fetch(`${baseUrl.replace(/\/$/, "")}/verifyOwnerAccess`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({})
      });
      if (!response.ok) {
        return { allowed: false, reason: `Owner verification failed with ${response.status}.` };
      }
      const payload = (await response.json()) as OwnerAccessResult;
      return payload.allowed ? { allowed: true, role: "owner" } : { allowed: false, reason: payload.reason };
    }
  };
}

export function createMockOwnerAccessRepository(): OwnerAccessRepository {
  return {
    async verifyOwner() {
      return { allowed: true, role: "owner" };
    }
  };
}
